import { EditOutlined } from '@ant-design/icons'
import { Switch } from 'antd'
import React, { useState } from 'react'
import { ProductSelector } from './product-selector'
import { QueryProducts } from './query-products'

export default function ProductSelectorOrQuery({ id, query = {}, setQuery }) {
  const [editQuery, setEditQuery] = useState(
    () => Object.keys(query).length !== 1 || !Array.isArray(query.groups)
  )

  function changeMode() {
    setEditQuery((v) => !v)
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: 5,
          alignItems: 'flex-end',
        }}
      >
        <label className="label mt10">Products</label>
        <Switch
          checkedChildren={<EditOutlined />}
          unCheckedChildren={<EditOutlined />}
          onChange={changeMode}
        />
      </div>
      {editQuery ? (
        <QueryProducts id={id} query={query} onChange={setQuery} />
      ) : (
        <ProductSelector
          id={id}
          type="group"
          products={query?.groups || []}
          onChange={(groups) => setQuery({ ...query, groups })}
        />
      )}
    </div>
  )
}
